import classNames from 'classnames/bind';
import styles from './analyzing.module.scss';

const cx = classNames.bind(styles);

const Analyzing = () => {
  return (
    <div className={cx('resultArea')}>
      <div className={cx('textArea')}>
        <p className={cx('text')}>
          응시 결과를 분석 중이에요.
          <br />
          결과 분석에는 최대 1일이 소요될 수 있어요.
        </p>
      </div>
    </div>
  );
};

export default Analyzing;
